import GeneralSettings from './GeneralSettings';
export default GeneralSettings;
